const APP_CONFIGS = {
	buildingName: "ЖК «Серебрица»",
	buildingLatLng: {
		lat: 55.82654485,
		lng: 37.23891061
	},
	gmapsStyles: [
		{
			featureType: "all",
			elementType: "labels.text.fill",
			stylers: [
				{
					color: "#736c68"
				}
			]
		},
		{
			featureType: "landscape.man_made",
			elementType: "geometry.fill",
			stylers: [
				{
					color: "#e7e6e5"
				}
			]
		},
		{
			featureType: "landscape.natural",
			elementType: "all",
			stylers: [
				{
					visibility: "on"
				},
				{
					color: "#d4e4d3"
				}
			]
		},
		{
			featureType: "poi",
			elementType: "geometry.fill",
			stylers: [
				{
					visibility: "on"
				},
				{
					color: "#f5f5f5"
				}
			]
		},
		{
			featureType: "poi.park",
			elementType: "geometry.fill",
			stylers: [
				{
					color: "#d4e4d3"
				}
			]
		},
		{
			"featureType": "poi.business",
			"stylers": [
			  {
				"visibility": "off"
			  }
			]
		  },
		{
			featureType: "road",
			elementType: "geometry.fill",
			stylers: [
				{
					color: "#f5f5f5"
				}
			]
		},
		{
			featureType: "road",
			elementType: "geometry.stroke",
			stylers: [
				{
					color: "#e7e6e5"
				},
				{
					gamma: "0.65"
				},
				{
					lightness: "0"
				}
			]
		},
		{
			featureType: "transit",
			elementType: "labels.text",
			stylers: [
				{
					visibility: "off"
				}
			]
		},
		{
			featureType: "water",
			elementType: "all",
			stylers: [
				{
					color: "#aad5df"
				}
			]
		}
	]
};

$.extend($.fancybox.defaults, {
	hash: false,
	infobar: true,
	buttons: ["close"],
	margin: [40, 40],
	lang: "ru",
	transitionEffect: "fade",
	touch: {
		vertical: false,
		momentum: true
	},
	mobile: {
		clickContent: false
	},

	i18n: {
		ru: {
			CLOSE: "Закрыть",
			NEXT: "Далее",
			PREV: "Назад",
			ERROR: "Не удалось открыть галерею - попробуйте позже",
			PLAY_START: "Запустить слайдшоу",
			PLAY_STOP: "Пауза",
			FULL_SCREEN: "На весь экран",
			THUMBS: "Миниатуры"
		}
	},
	/*btnTpl : {
        smallBtn   : '<button data-fancybox-close class="Btn Btn-modalClose" title="{{CLOSE}}"><svg class="SvgIco" height="13" viewBox="0 0 13 13" width="13" xmlns="http://www.w3.org/2000/svg"><path class="SvgIco_path" d="m532.31 19.31h7v2h-7v7h-2v-7h-7v-2h7v-7h2z"  fill-rule="evenodd" transform="matrix(.70710678 .70710678 -.70710678 .70710678 -355.02 -383.75)"/></svg></button>',
    },*/

	afterClose: function() {
		if (this.src === '#calculator-email') {
			let $this = this.$content;

			$this.find('.calculator-form').show();
			$this.find('.calculator-email__tlt').text('Отправить на почту');
			$this.find('p').text('Введите ваш e-mail, и мы отправим вам рассчет ипотеки');
		}
		if (this.type === "inline") {
			let $form = this.$content.find("form");
			let validator = $form.trigger("reset").data("validator");
			if (validator) {
				validator.resetForm();
				$form.find("input.error").removeClass("error");
			}

			let $successText = this.$content.find(".Form_success");
			if ($successText.length) {
				$form.show();
				$successText.remove();
			}
		}
	}
});

class Accordion {
	constructor(el, conf) {
		let $el = $(el);

		if (!$el.length) {
			console.error("Accordion class constructor cant't find target element!");
			return;
		}

		const setting = {
			icons: false,
			heightStyle: "content",
			collapsible: true,
			classes: {
				"ui-accordion-header": "",
				"ui-accordion-content": "",
				"ui-accordion-header-active": "Accordion_label-active"
			}
		};
		$el.accordion($.extend(true, setting, conf));

		this.$el = $el;
	}
}

class ArticleBurger {
	constructor(element) {
		let $el = $(element);

		if (!$el.length) {
			console.error("ArticleBurger class constructor cant't find target element!");
			return;
		}

		this.$el = $el;
		this.scrollLinks();
	}

	scrollLinks() {
		const links = this.$el.find('[data-scrollTo]');

		links.on('click', function (e) {
			e.preventDefault();

			const dataLink = $(this).data('scrollto');
			const title = $(document).find(`[data-titlescroll="${dataLink}"]`);

			$('html, body').animate({
				scrollTop: title.offset().top
			}, 2000);
		})
	}
}
class BackToTop {
	constructor() {
		let $el = $('<a class="BackToTop compensate-for-scrollbar" href="#" title="к началу"></a>');
		let $window = $(window);

		$window.on(
			"scroll.BackToTopListenter",
			_.throttle(() => {
				if ($window.scrollTop() > 200) {
					$el.fadeIn();
				} else {
					$el.fadeOut();
				}
			}, 100)
		);

		$el
			.on("click", event => {
				event.preventDefault();
				$("html, body").animate({ scrollTop: 0 }, 600);
				return false;
			})
			.appendTo("body");
	}
}

class Bird {
	constructor($targetEl, opts = {}) {
		let $bird = $(".Bird").eq(0);
		const positionFrom = $bird.position();
		const positionTo = $targetEl.position();
		const fromY = positionFrom.top;
		const fromX = positionFrom.left;
		let toX = positionTo.left + $targetEl.width() / 2 - 26;
		let toY = positionTo.top + $targetEl.height() / 2 + 30;

		const $birdAnimated = $(".Bird-animate");

		this.tl = new TimelineLite({
			paused: true,
			onComplete() {
				TweenLite.to($birdAnimated, 0.3, {
					opacity: 0,
					onComplete() {
						$birdAnimated.css("display", "none");
					}
				});
				$targetEl.css("opacity", "1");
			}
		});
		this.tl.addLabel("bird");
		this.tl.to($bird, 0, { top: fromY, left: fromX });
		this.tl.fromTo($bird, 0.9, { opacity: 0 }, { opacity: 1 }, "+0.4");
		this.tl.to($bird, 0, { className: "+=Bird-flipHead" }, "+=0.2");
		this.tl.addLabel("fly", "+=0.3");
		this.tl.to(
			$bird,
			0.2,
			{
				opacity: 0,
				onComplete() {
					$bird.css("display", "none");
				}
			},
			"fly"
		);
		this.tl.fromTo($birdAnimated, 0.2, { opacity: 0 }, { opacity: 1 }, "fly");
		this.tl.to(
			{
				top: fromY,
				left: fromX
			},
			2,
			{
				top: toY,
				left: toX,
				ease: Power0.easeNone,
				autoCSS: false,
				onUpdate(tween) {
					let koef = 10;
					if (tween.time() >= 0.5) {
						koef = 15;
					} else if (tween.time() >= 1) {
						koef = 25;
					}
					if (tween.time() >= 1.5) {
						koef = 30;
					}
					$birdAnimated.css("top", tween.target.top - koef * Math.sin(tween.time() * 6.4));
					$birdAnimated.css("left", tween.target.left);
				},
				onUpdateParams: ["{self}"],
				onUpdateScope: this
			},
			"fly"
		);
	}
	startAnimation() {
		this.tl.play();
	}
}

class CardsList {
	constructor(opts) {
		this.tpl = _.template(opts.tpl.replace(/\s{2,}/g, ""));
		this.additionalClassName = opts.additionalClassName;
	}

	renderCards(dataToRender) {
		dataToRender.declOfNum = this.declOfNum;
		let markup = this.tpl(dataToRender);

		let resultMarkup = `<div class="CardsList ${
			this.additionalClassName ? this.additionalClassName : ""
		}">${markup}</div>`;

		return resultMarkup;
	}

	declOfNum(number, titles) {
		let cases = [2, 0, 1, 1, 1, 2];
		return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
	}
}

function CustomMarker(map, icon, content, coord, isNeedHover = false) {
	this.map_ = map;
	this.isHover = isNeedHover;
	this.icon_ = icon;
	this.content_ = content;
	this.coord_ = coord;
	this.div_ = null;
	this.draw = () => {
		const overlayProjection = this.getProjection();
		let position = overlayProjection.fromLatLngToDivPixel(this.coord_);
		this.div_.style.left = position.x - 30 + "px";
		this.div_.style.top = position.y - 60 + "px";
	};
	this.onAdd = () => {
		const div = document.createElement("div");
		div.classList.add("marker");
		if (this.isHover) {
			div.classList.add("marker-hover");
		}
		div.innerHTML = `<div class="marker_ico" style="background-image: url(${
			this.icon_
		})"></div><div class="marker_textWrp"><div class="marker_text"><span>${this.content_}</span></div></div>`;
		const marker = this;
		google.maps.event.addDomListener(div, "click", function() {
			google.maps.event.trigger(marker, "click");
		});
		this.div_ = div;
		const panes = this.getPanes();
		panes.overlayMouseTarget.appendChild(this.div_);
	};
	this.setMap(map);
	this.getPosition = function() {
		return coord;
	};
	this.remove = function(/*event*/) {
		this.div_.remove();
	};
}

CustomMarker.prototype = new google.maps.OverlayView() || $.noop;

class ContactMaps {
	constructor(officeCoord, routeSetting, checkSizeBlock) {
		this.officeCoord = officeCoord;
		this.routeSetting = routeSetting;
		this.checkSizeBlock = checkSizeBlock;
		this.gmaps = new GMaps({
			el: "#contactsMap",
			center: this.officeCoord,
			disableDefaultUI: true,
			zoomControl: true,
			zoom: 16,
			styles: APP_CONFIGS.gmapsStyles,
			streetViewControl: true,
			streetViewControlOptions: {
				position: google.maps.ControlPosition.LEFT_BOTTOM
			},
		});
		this.lineSymbol = {
			path: "M 0,-1 0,1",
			strokeOpacity: 1,
			strokeColor: "#c43f60",
			strokeWeight: 6,
			scale: 4
		};
		this.showType = "office";
		$(window).resize(() => {
			this.setCheckSize();
		});
		this.setCheckSize();
		new CustomMarker(this.gmaps.map, "/img/map_markers/office_contacts.png", "Офис продаж", this.officeCoord);
	}

	setCheckSize() {
		this.checkSize = parseFloat(this.checkSizeBlock.width()) + parseFloat(this.checkSizeBlock.css("right"));
		if (window.innerWidth < 768) {
			this.checkSize = 0;
		}
		if (this.showType == "office") {
			this.setCenterOffice();
		} else {
			this.fitBoundsWithPadding(this.gmaps.map, [this.officeCoord].concat(this.routeSetting.map(item => item.coord)), {
				right: this.checkSize
			});
		}
	}

	fitBoundsWithPadding(map, coords, paddingXY) {
		var bounds = new google.maps.LatLngBounds();
		coords.forEach(item => bounds.extend(item));
		var projection = map.getProjection();
		if (projection) {
			if (!$.isPlainObject(paddingXY)) paddingXY = { x: 0, y: 0 };

			var paddings = {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			};

			if (paddingXY.left) {
				paddings.left = paddingXY.left;
			} else if (paddingXY.x) {
				paddings.left = paddingXY.x;
				paddings.right = paddingXY.x;
			}

			if (paddingXY.right) {
				paddings.right = paddingXY.right;
			}

			if (paddingXY.top) {
				paddings.top = paddingXY.top;
			} else if (paddingXY.y) {
				paddings.top = paddingXY.y;
				paddings.bottom = paddingXY.y;
			}

			if (paddingXY.bottom) {
				paddings.bottom = paddingXY.bottom;
			}

			// copying the bounds object, since we will extend it
			bounds = new google.maps.LatLngBounds(bounds.getSouthWest(), bounds.getNorthEast());

			// SW
			var point1 = projection.fromLatLngToPoint(bounds.getSouthWest());
			map.fitBounds(bounds);

			var point2 = new google.maps.Point(
				(typeof paddings.left == "number" ? paddings.left : 0) / Math.pow(2, map.getZoom()) || 0,
				(typeof paddings.bottom == "number" ? paddings.bottom : 0) / Math.pow(2, map.getZoom()) || 0
			);

			var newPoint = projection.fromPointToLatLng(new google.maps.Point(point1.x - point2.x, point1.y + point2.y));

			bounds.extend(newPoint);

			// NE
			point1 = projection.fromLatLngToPoint(bounds.getNorthEast());
			point2 = new google.maps.Point(
				(typeof paddings.right == "number" ? paddings.right : 0) / Math.pow(2, map.getZoom()) || 0,
				(typeof paddings.top == "number" ? paddings.top : 0) / Math.pow(2, map.getZoom()) || 0
			);
			newPoint = projection.fromPointToLatLng(new google.maps.Point(point1.x + point2.x, point1.y - point2.y));

			bounds.extend(newPoint);

			map.fitBounds(bounds);
		}
	}

	showRoute() {
		this.showType = "route";
		this.routeSetting.forEach(item => {
			if (item.type !== "walk") {
				this.gmaps.drawRoute({
					origin: [parseFloat(item.coord.lat()), parseFloat(item.coord.lng())],
					destination: this.endTransportPoint,
					travelMode: "driving",
					strokeColor: "#9893c0",
					strokeOpacity: 1,
					strokeWeight: 6
				});
			} else {
				this.endTransportPoint = [parseFloat(item.coord.lat()), parseFloat(item.coord.lng())];
				let directionsService = new google.maps.DirectionsService();
				directionsService.route(
					{
						origin: item.coord,
						destination: this.officeCoord,
						travelMode: google.maps.DirectionsTravelMode.WALKING,
						optimizeWaypoints: false
					},
					(result /*, status*/) => {
						this.gmaps.walkRoute = new google.maps.Polyline({
							path: result.routes[0].overview_path,
							strokeOpacity: 0,
							icons: [
								{
									icon: this.lineSymbol,
									offset: "0",
									repeat: "25px"
								}
							],
							map: this.gmaps.map
						})
					}
				);
			}
		});
		this.fitBoundsWithPadding(this.gmaps.map, [this.officeCoord].concat(this.routeSetting.map(item => item.coord)), {
			right: this.checkSize
		});
	}

	setCenterOffice() {
		this.showType = "office";
		this.gmaps.map.setCenter(this.officeCoord);
		this.gmaps.map.setZoom(16);
		this.gmaps.map.panBy(this.checkSize / 2, 0);
	}

	hideRoute() {
		this.gmaps.cleanRoute();
		if (this.gmaps.walkRoute != undefined) this.gmaps.walkRoute.setMap(null);
	}
}

class CustomBurger {
	constructor(el) {
		this.ignoreHovers = false;
		let $el = $(el);
		let $paths = $el.find("svg").find("path");
		let $hoverPaths = $(`
        <svg width="48" height="33" xmlns="http://www.w3.org/2000/svg"><path d="M21.667 28.294c1.965 2.608 4.896 4.158 8.216 4.65.443-3.327-.24-6.573-2.204-9.18-1.965-2.608-4.898-4.16-8.219-4.652-.443 3.33.242 6.575 2.207 9.182" fill="#859938" opacity=".897"/><path d="M21.804 4.512c-2.1 2.501-2.95 5.706-2.684 9.052 3.343-.317 6.351-1.713 8.45-4.213 2.1-2.501 2.952-5.708 2.685-9.055-3.343.318-6.352 1.715-8.45 4.216" fill="#859938" opacity=".897"/><path fill="#575759" d="M0 17h48v-2H0z"/><path fill="#575759" d="M43.945 10.441l-6.53 6.477L36 15.504l6.53-6.477z"/><path fill="#575759" d="M6 16.414l7.142 7.143 1.415-1.414L7.414 15z"/></svg>
        `).find("path");

		let $semiclosePaths = $(`
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="33"><path d="M22.809 23.929c2.03 1.27 4.445 1.56 6.847 1.025-.571-2.395-1.891-4.437-3.921-5.706-2.031-1.269-4.447-1.56-6.85-1.025.572 2.396 1.894 4.438 3.924 5.706" opacity=".897" fill="#859938"/><path d="M22.908 8.351c-2.114 1.124-3.574 3.069-4.311 5.417 2.36.703 4.789.58 6.903-.543 2.114-1.124 3.574-3.07 4.312-5.42-2.36-.702-4.79-.579-6.904.546" opacity=".897" fill="#859938"/><path d="M7.585 17.082h33v-2h-33z" fill="#575759"/><path d="M36.53 10.523L30 17l-1.415-1.414 6.53-6.477z" fill="#575759"/><path d="M11.585 16.496l7.142 7.143 1.415-1.414-7.143-7.143z" fill="#575759"/></svg>
        `).find("path");

		let $closePaths = $(`
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="33"><path d="M32.142 10L19.414 22.728 18 21.314 30.728 8.586z"/><path d="M18 10l12.728 12.728 1.414-1.414L19.414 8.586z"/></svg>
        
        
        `).find("path");
		let tl = new TimelineLite({ paused: true });

		tl.addLabel("animeStart")
			.to($paths.eq(0), 0.2, { morphSVG: $hoverPaths.eq(0), ease: Linear.easeNone }, "animeStart")
			.to($paths.eq(1), 0.2, { morphSVG: $hoverPaths.eq(1), ease: Linear.easeNone }, "animeStart")
			.to($paths.eq(2), 0.2, { morphSVG: $hoverPaths.eq(2), ease: Linear.easeNone }, "animeStart")
			.to($paths.eq(3), 0.2, { morphSVG: $hoverPaths.eq(3), ease: Linear.easeNone }, "animeStart")
			.to($paths.eq(4), 0.2, { morphSVG: $hoverPaths.eq(4), ease: Linear.easeNone }, "animeStart")
			.addPause()
			.addLabel("semiCloseStart")
			.to($paths.eq(0), 0.1, { morphSVG: $semiclosePaths.eq(0), ease: Linear.easeNone }, "semiCloseStart")
			.to($paths.eq(1), 0.1, { morphSVG: $semiclosePaths.eq(1), ease: Linear.easeNone }, "semiCloseStart")
			.to($paths.eq(2), 0.1, { morphSVG: $semiclosePaths.eq(2), ease: Linear.easeNone }, "semiCloseStart")
			.to($paths.eq(3), 0.1, { morphSVG: $semiclosePaths.eq(3), ease: Linear.easeNone }, "semiCloseStart")
			.to($paths.eq(4), 0.1, { morphSVG: $semiclosePaths.eq(4), ease: Linear.easeNone }, "semiCloseStart")
			.addLabel("closeStart")
			.to($paths.eq(0), 0.1, { morphSVG: $closePaths.eq(0), ease: Linear.easeNone }, "closeStart")
			.to($paths.eq(1), 0.1, { morphSVG: $closePaths.eq(0), ease: Linear.easeNone }, "closeStart")
			.to($paths.eq(2), 0.1, { morphSVG: $closePaths.eq(0), ease: Linear.easeNone }, "closeStart")
			.to($paths.eq(3), 0.1, { morphSVG: $closePaths.eq(1), ease: Linear.easeNone }, "closeStart")
			.to($paths.eq(4), 0.1, { morphSVG: $closePaths.eq(1), ease: Linear.easeNone }, "closeStart");

		$el.hover(
			() => {
				if (this.ignoreHovers) return false;
				tl.play();
			},
			() => {
				if (this.ignoreHovers) return false;
				tl.reverse();
			}
		);

		this.$el = $el;
		this.tl = tl;
	}

	drawClosedBurger() {
		this.ignoreHovers = true;
		this.tl.gotoAndPlay("semiCloseStart");
	}

	reset() {
		this.tl.gotoAndStop("animeStart");
		this.ignoreHovers = false;
	}
}

class DiarySliders {
	constructor(diary, diaryThumb) {
		let settings = {
			diary: {
				slidesPerView: "auto",
				spaceBetween: 45,
				centeredSlides: true,
				speed: 900,
				navigation: {
					nextEl: ".diary_btn-next",
					prevEl: ".diary_btn-prev"
				},
				breakpoints: {
					767: {
						slidesPerView: 1,
						spaceBetween: 48
					}
				},
				on: {
					resize: function() {
						if (window.innerWidth >= 1440) {
							this.slides.css("width", "");
						}
					}
				}
			},
			diarySub: {
				slidesPerView: "auto",
				centeredSlides: true,
				speed: 900,
				spaceBetween: 48,
				navigation: {
					nextEl: ".diary_btn-next",
					prevEl: ".diary_btn-prev"
				},
				breakpoints: {
					1439: {
						spaceBetween: 49,
						slidesPerView: 1
					}
				},
				on: {
					init: function() {
						$(".diaryTop_count-total").text(this.slides.length);
					},
					slideChange: function() {
						$(".diaryTop_count-current").text(this.realIndex + 1);
					},
					resize: function() {
						if (window.innerWidth >= 1440) {
							this.slides.css("width", "");
						}
					}
				}
			},
			diaryThumb: {
				slidesPerView: "auto",
				centeredSlides: true,
				speed: 900,
				slideToClickedSlide: true,
				spaceBetween: 50,
				freeMode: true
			}
		};
		if (diary.length) {
			const isSub = diary.hasClass("diary-sub");
			let diarySlider = new Swiper(diary, isSub ? settings.diarySub : settings.diary);
			if (!isSub) {
				let thumbDiary = new Swiper(diaryThumb, settings.diaryThumb);
				diarySlider.controller.control = thumbDiary;
				thumbDiary.controller.control = diarySlider;
			}
		}

		$(".diaryTop_select select")
			.selectmenu({
				appendTo: ".diaryTop_select"
			})
			.on("selectmenuchange", function(/*event, ui*/) {
				window.location =
					"/be_aware/dynamics-construction/" + $("select[name=type]").val() + "/" + $("select[name=year]").val() + "/";
			});
	}
}

class FilterForm {
	constructor(el, opts) {
		if (!el) {
			console.error('Filter class constructor requires "el" argument!');
			return;
		}

		let defaultOpts = {
			submitHandler: $.noop,
		};

		opts = $.extend(defaultOpts, opts);

		this.lastChangedField = null;
		const submitHandler = _.debounce(opts.submitHandler, 700);

		let $filterForm = $(el);
		this.$filterForm = $filterForm;

		this.restoreStateFromURL();

		if (!$filterForm.length) {
			console.error('FilterForm constructor can\'t find given "el" in DOM!');
			return;
		}

		let multicheckboxes = [];
		$filterForm.find(".Multycheckbox").each((index, el) => {
			multicheckboxes.push(new Multicheckbox(el));
		});

		let rangeSliders = [];
		$filterForm.find(".RangeSlider").each((index, el) => {
			rangeSliders.push(new RangeSlider(el));
		});

		let $inputs = $($filterForm.get(0).elements);

		$inputs.on("change", (event) => {
			event.preventDefault();
			this.lastChangedField = event.currentTarget.name;
			$filterForm.trigger("submit");
		});

		$filterForm.find('.RangeSlider_valViewWrap').on("focusout", (event) => {
			$filterForm.trigger("submit");
		});

		$filterForm
			.on("submit", (event) => {
				event.preventDefault();
				this.saveStateToURL();
				submitHandler(this);
				return false;
			})
			.trigger("submit");

		$filterForm.find(".FilterForm_groupToggler").on("click", (event) => {
			event.preventDefault();
			let $toggler = $(event.currentTarget);
			$toggler.toggleClass("FilterForm_groupToggler-active");

			let $group = filter.$filterForm.find($toggler.data("form-group-toggle"));
			$group.toggle();

			if ($group.is(":visible")) {
				sidebar.$scroller.animate({ scrollTop: $group.offset().top }, 500);
			}
		});

		this.$inputs = $inputs;
		this.rangeSliders = rangeSliders;
		this.multicheckboxes = multicheckboxes;
	}

	resetFilterForm() {
		this.$filterForm[0].reset();
		this.rangeSliders.forEach((rangeSliderInst) => {
			rangeSliderInst.reset();
		});

		this.multicheckboxes.forEach((multiCheckboxInst) => {
			multiCheckboxInst.reset();
		});
	}

	resetChecksGroup() {
		let $checksGroup = this.$filterForm.eq(0).find('.FilterForm_chksGroup-groupBlock');
		// let multicheckboxes = [];
		$checksGroup.find(".Multycheckbox_inp").each((index, el) => {
			// multicheckboxes.push(new Multicheckbox(el));

			$(el).val('2');
			$(el).trigger('change')
		});

		// multicheckboxes.forEach((multiCheckboxInst) => {
		// 	multiCheckboxInst.reset();
		// });
	}

	parseQueryString(string) {
		if (string === "" || string == null) return {};
		if (string.charAt(0) === "?") string = string.slice(1);
		var entries = string.split("&"),
			data0 = {},
			counters = {};
		for (var i = 0; i < entries.length; i++) {
			var entry = entries[i].split("=");
			var key5 = decodeURIComponent(entry[0]);
			var value = entry.length === 2 ? decodeURIComponent(entry[1]) : "";
			if (value === "true") value = true;
			else if (value === "false") value = false;
			var levels = key5.split(/\]\[?|\[/);
			var cursor = data0;
			if (key5.indexOf("[") > -1) levels.pop();
			for (var j = 0; j < levels.length; j++) {
				var level = levels[j],
					nextLevel = levels[j + 1];
				var isNumber = nextLevel == "" || !isNaN(parseInt(nextLevel, 10));
				var isValue = j === levels.length - 1;
				if (level === "") {
					var key5 = levels.slice(0, j).join();
					if (counters[key5] == null) counters[key5] = 0;
					level = counters[key5]++;
				}
				if (cursor[level] == null) {
					cursor[level] = isValue ? value : isNumber ? [] : {};
				}
				cursor = cursor[level];
			}
		}
		return data0;
	}

	saveStateToURL() {
        if ( $("#filterFormHorizon").hasClass("pantry-filter") )
            return;

		let queryStr = this.$filterForm.serialize();
		let newURL = location.pathname + "?" + queryStr;
		history.replaceState({}, document.title, newURL);
	}

	restoreStateFromURL() {
        if ( $("#filterFormHorizon").hasClass("pantry-filter") )
            return;

		let storedValues = this.parseQueryString(window.location.search);
		let $inps = $(this.$filterForm.get(0).elements);

		for (let p in storedValues) {
			if (storedValues.offset) {
				this.offset = storedValues.offset;
			}
			// TODO: optimize selector for filtering inputs
			$inps.filter(`[name='${p}'], [name='${p}[]']`).each((index, el) => {
				if (el.type && (el.type === "checkbox" || el.type === "radio")) {
					let isChecked = true;

					if (_.isArray(storedValues[p])) {
						isChecked = _.includes(storedValues[p], el.value);
					}

					el.checked = isChecked;
				} else if (el.tagName === "SELECT") {
					if (storedValues[p]) {
						for (var i = 0; i < el.options.length; i++) {
							let opt = el.options[i];
							if (storedValues[p].includes(opt.value)) {
								opt.selected = "selected";
							}
						}
					}
				} else {
					el.value = storedValues[p];
				}
			});
		}
	}
}

class FilterSidebar {
	constructor(el) {
		let $el = $(el);

		if ($el.length === 0) {
			console.error('FilterSidebar constructor can\'t find given "el" in DOM!');
			return;
		}

		this.$headerLogoEl = $(".Header_logo");

		this.$scroller = $el.find(".FilterSidebar_scroll");

		this.isHorizontal = $el.hasClass('FilterSidebar-horizontal');

		this.isNotFixed = $el.hasClass('FilterSidebar-notFixed');

		if (!this.isNotFixed) {
			this.$headerLogoEl.addClass("Header_logo-fixed").appendTo("main");
		}

		if (!this.isHorizontal) {
			new PerfectScrollbar(this.$scroller.get(0), {
				suppressScrollX: true,
				swipeEasing: false,
				wheelPropagation: false
			});
		}

		if (!this.isHorizontal) {
			$el.on("touchmove", event => {
				event.preventDefault();
				return false;
			});
	
			if (currentDevice.desktop()) {
				$el.hover(
					() => {
						this.show();
					},
					() => {
						this.hide();
					}
				);
			} else {
				$el.find(".FilterSidebar_grip").on("click", event => {
					event.preventDefault();
					this.toggle();
				});
			}
		}

		this.$el = $el;
	}

	show() {
		this.$el.addClass("FilterSidebar-active");
		this.$headerLogoEl.addClass("Header_logo-notShadowed");
	}

	hide() {
		this.$el.removeClass("FilterSidebar-active");
		this.$headerLogoEl.removeClass("Header_logo-notShadowed");
	}

	toggle() {
		if (this.$el.hasClass("FilterSidebar-active")) {
			this.hide();
		} else {
			this.show();
		}
	}

	addToggler(selector) {
		$(selector).on("click", event => {
			event.preventDefault();
			this.toggle();
		});
	}
}

class Fitblock {
	constructor(el) {
		this.outer = el;
		this.$el = $(el);
		if (!$(el).length) return;
		this.inner = el.getElementsByClassName("Fitblock_inner")[0];
		this.pusher = this.inner.getElementsByClassName("Fitblock_pusher")[0];

		$(window).on(
			"resize.fitblocks",
			_.debounce(() => {
				this.refresh();
			}, 80)
		);

		if (this.pusher.complete || this.pusher.readyState === 4) {
			this.inner.style.visibility = "visible";
			this.refresh();
		} else {
			$(this.pusher).on("load", () => {
				this.inner.style.visibility = "visible";
				this.refresh();
			});
		}
	}

	refresh() {
		let outer = this.outer;
		let inner = this.inner;
		let pusher = this.pusher;
		let wrapH = outer.offsetHeight;
		let wrapW = outer.offsetWidth;

		let pusherH = pusher.naturalHeight;
		let pusherW = pusher.naturalWidth;

		let rel = pusherW / pusherH;
		if (wrapW / pusherW > wrapH / pusherH) {
			pusher.style.width = `${wrapW}px`;
			pusher.style.height = "auto";
			inner.style.marginLeft = `-${wrapW / 2}px`;
			inner.style.marginTop = `-${wrapW / rel / 2}px`;
		} else {
			pusher.style.width = "auto";
			pusher.style.height = `${wrapH}px`;
			inner.style.marginLeft = `-${(wrapH * rel) / 2}px`;
			inner.style.marginTop = `-${wrapH / 2}px`;
		}
	}

	destroy() {
		$(window).off(".fitblocks");
	}
}

class FitblockWithClouds {
	constructor(el) {
		this.outer = el;
		this.$el = $(el);
		this.inner = el.getElementsByClassName("Fitblock_inner")[0];
		this.pusher = this.inner.getElementsByClassName("Fitblock_pusher")[0];
		this.cloud = this.inner.getElementsByClassName("Fitblock_cloud")[0];

		let $window = $(window);

		$window.on(
			"resize.fitblocks",
			_.debounce(() => {
				this.refresh();
			}, 80)
		);

		if (this.pusher.complete || this.pusher.readyState === 4) {
			this.inner.style.visibility = "visible";
			this.refresh();
		} else {
			$(this.pusher).on("load", () => {
				this.inner.style.visibility = "visible";
				this.refresh();
			});
		}

		this.initAnimate(this.inner, this.cloud, this.pusher, $window);
	}

	refresh() {
		let outer = this.outer;
		let inner = this.inner;
		let pusher = this.pusher;
		let cloud = this.cloud;
		let wrapH = outer.offsetHeight;
		let wrapW = outer.offsetWidth;

		let pusherH = pusher.naturalHeight;
		let pusherW = pusher.naturalWidth;

		let rel = pusherW / pusherH;

		if (wrapW / pusherW > wrapH / pusherH) {
			pusher.style.width = `${wrapW + 50}px`;
			pusher.style.height = "auto";
			cloud.style.width = `${wrapW}px`;
			cloud.style.height = "auto";
			inner.style.width = `${wrapW + 50}px`;
			inner.style.marginLeft = `-${wrapW / 2}px`;
			inner.style.marginTop = `-${wrapW / rel / 2}px`;
		} else {
			pusher.style.width = "auto";
			pusher.style.height = `${wrapH + 50}px`;
			cloud.style.width = "auto";
			cloud.style.height = `${wrapH}px`;
			inner.style.marginLeft = `-${(wrapH * rel) / 2}px`;
			inner.style.marginTop = `-${wrapH / 2}px`;
		}
	}

	initAnimate(inner, cloud, pusher, $window) {
		let $pusher = $(pusher);

		let centerX = $pusher.width() / 2;
		let centerY = $pusher.height() / 2;

		let koefX;
		let koefY;
		let shiftX;
		let shiftY;
		let shift = 50;

		let mouse = { x: 0, y: 0 };

		let easedPos = {
			x: window.innerWidth / 2,
			y: window.innerHeight / 2
		};

		$window.mousemove(function(e) {
			mouse.x = e.clientX;
			mouse.y = e.clientY;
		});

		let update = () => {
			TweenLite.to(easedPos, 1, {
				x: window.innerWidth / 2 - mouse.x,
				y: window.innerHeight / 2 - mouse.y,
				ease: Power0.easeOut
			});

			koefX = easedPos.x / centerX;
			koefY = easedPos.y / centerY;

			shiftX = (-25 + shift * koefX) / 2;
			shiftY = (-25 + shift * koefY) / 2;

			TweenLite.set([cloud, inner], {
				x: shiftX,
				y: shiftY
			});
		};

		TweenLite.ticker.addEventListener("tick", update);
	}

	destroy() {
		$(window).off(".fitblocks");
	}
}

class FlatsList {
	constructor(el, opts) {
		this.$el = $(el);
		this.$renderEl = $(opts.renderElement);
		if (opts.typeTemplates === 'commercial') {
					let tplStr = `
		<%
		let okIco = '<svg class="SvgIco SvgIco-checkBold" width="12" height="9" xmlns="http://www.w3.org/2000/svg">
					<path class="SvgIco_path" d="M10.071 0l1.768 1.767-7.071 7.071L3 7.07z"></path>
					<path class="SvgIco_path" d="M.491 4.509L2.26 2.74l3.567 3.567L4.06 8.076z"></path>
				</svg>';
		let crossIco = '<svg class="SvgIco SvgIco-crossBold" width="10" height="10" xmlns="http://www.w3.org/2000/svg"><path class="SvgIco_line" stroke-width="2" d="M1 9l8-8M1 1l8 8"></path></svg>'
		%>
		<% _.forEach(flats, function(flt) { %>
		<a class="Tbl_tr Tbl_tr-link" href="<%= flt.url %>">
			<div class="Tbl_td hidden-xs">
				<div class="Tbl_thumb" style="background-image:url('<%= flt.pic %>');" data-full-img="<%= flt.pic %>"></div>
			</div>
			<div class="Tbl_td"><%= flt.area %></div>
			<div class="Tbl_td"><%= flt.section %></div>
			<div class="Tbl_td"><%= flt.bldYear %><br/><span class="Tbl_bldTime"><%= flt.bldTime %> квартал</span></div>
			<div class="Tbl_td"><%= flt.status %></div>
			
			<% if(flt.oldPrice){ %>
				<div class="Tbl_td Tbl_td-nowrap">
					<del class="Tbl_delText"><%= flt.oldPrice.toLocaleString("ru-RU") %></del>
					<br>
					<ins class="Tbl_insText"><%= flt.price.toLocaleString("ru-RU") %></ins>
				</div>
			<% }else{ %>
				<div class="Tbl_td Tbl_td-nowrap"><%= flt.price.toLocaleString("ru-RU") %></div>
			<% }; %>
		</a>
		<% }); %>
		`;
		this.tpl = _.template(tplStr.replace(/\s{2,}/g, ""));
		} else {
					let tplStr = `
		<%
		let okIco = '<svg class="SvgIco SvgIco-checkBold" width="12" height="9" xmlns="http://www.w3.org/2000/svg">
					<path class="SvgIco_path" d="M10.071 0l1.768 1.767-7.071 7.071L3 7.07z"></path>
					<path class="SvgIco_path" d="M.491 4.509L2.26 2.74l3.567 3.567L4.06 8.076z"></path>
				</svg>';
		let crossIco = '<svg class="SvgIco SvgIco-crossBold" width="10" height="10" xmlns="http://www.w3.org/2000/svg"><path class="SvgIco_line" stroke-width="2" d="M1 9l8-8M1 1l8 8"></path></svg>'
		%>
		<% 
		  let promoCardsOrders = [];
		  promos.forEach(function(promoCard){
			promoCardsOrders.push(promoCard.order - 1);
		  });
		
		  var eachFlatCardIteration = 0;
		%>
		<% _.forEach(flats, function(flt) { %>
		<% if(_.includes(promoCardsOrders, eachFlatCardIteration)){ %>
			<% let promo = promos.shift(); console.log(promo);%>
					<div class="Tbl_tr Tbl_tr-link Promotion">
						<div class="Promotion_name"><%= promo.title %></div>
		        <a href="<%= promo.link %>" class="Tbl_rowLink"></a>
		        <a href="<%= promo.link %>" class="Btn Btn-color4 BtnOnlineBuy_btn">Узнать подробнее</a>
					</div>
			<% eachFlatCardIteration++ %>
		<% }; %>
					<div class="Tbl_tr Tbl_tr-link">
			<div class="Tbl_td hidden-xs">
				<div class="Tbl_thumb" style="background-image:url('<%= flt.pic %>');" data-full-img="<%= flt.pic %>"></div>
			</div>
			<div class="Tbl_td"><%= flt.num %></div>
			<div class="Tbl_td"><%= flt.floor %></div>
			<div class="Tbl_td hidden-xs hidden-sm"><%= flt.section %></div>
			<div class="Tbl_td"><%= flt.bld %></div>
			<div class="Tbl_td"><%= flt.rooms %></div>
			<div class="Tbl_td"><%= flt.area %> м<sup>2</sup></div>
			<div class="Tbl_td hidden-xs hidden-sm">
				<% if(flt.furnish){ %>
					<%= okIco %>
				<% }else{ %>
					<%= crossIco %>
				<% }; %>
			</div>
			
			<% if(flt.oldPrice){ %>
				<div class="Tbl_td Tbl_td-nowrap">
					<del class="Tbl_delText"><%= flt.oldPrice.toLocaleString("ru-RU") %> ₽</del>
					<br>
					<ins class="Tbl_insText"><%= flt.price.toLocaleString("ru-RU") %> ₽</ins>
					<a class="Tbl_rowLink" href="<%= flt.url %>"></a>
				</div>
			<% }else{ %>
				<div class="Tbl_td Tbl_td-nowrap">
				    <%= flt.price.toLocaleString("ru-RU") %> ₽
				</div>
			<% }; %>
		
		    <div class="Tbl_td BtnOnlineBuy">
		        <a href="<%= flt.onlineBuy %>" data-btn-buyonline class="Btn Btn-color3 BtnOnlineBuy_btn">Купить онлайн</a>
		    </div>
		    <a class="Tbl_rowLink" href="<%= flt.url %>"></a>
		</div>
		<div class="Tbl_tr _sm">
		    <a href="<%= flt.onlineBuy %>" data-btn-buyonline class="Btn Btn-color3 BtnOnlineBuy_btn _sm">Купить онлайн</a>
		</div>
		<% eachFlatCardIteration++ %>
		<% }); %>
		
		`;
		this.tpl = _.template(tplStr.replace(/\s{2,}/g, ""));
	}
		}

		

	render(dataToRender) {
		let markup = this.tpl(dataToRender);
		this.$renderEl.html(markup);
	}

	append(dataToRender) {
		let markup = this.tpl(dataToRender);
		this.$renderEl.append(markup);
	}
}

class InlineGallery {
	constructor(gallery, elFancy) {
		let settings = {
			gallery: {
				slidesPerView: "auto",
				spaceBetween: 45,
				centeredSlides: true,
				speed: 900,
				navigation: {
					nextEl: ".gallery__btn--next",
					prevEl: ".gallery__btn--prev"
				},
				breakpoints: {
					767: {
						slidesPerView: 1,
						spaceBetween: 48
					}
				}
			},
			galleryDetail: {
				slidesPerView: "auto",
				centeredSlides: true,
				speed: 900,
				spaceBetween: 48,
				navigation: {
					nextEl: ".gallery__btn--next",
					prevEl: ".gallery__btn--prev"
				},
				breakpoints: {
					1439: {
						spaceBetween: 49,
						slidesPerView: 1
					}
				},
				on: {
					init: function() {
						$(".gallery-count__total").text(this.slides.length);
					},
					slideChange: function() {
						$(".gallery-count__current").text(this.realIndex + 1);
					},
					beforeResize() {
						if (window.innerWidth >= 1440) {
							this.slides.css("width", "");
						}
					}
				}
			},
			fancybox: {
				openEffect: "none",
				closeEffect: "none",
				arrows: true,
				speed: 900,
				buttons: ["close"],
				baseClass: "gallery-fancybox",
				baseTpl: `<div class="fancybox-container" role="dialog" tabindex="-1">
					<div class="fancybox-bg"></div>
					<div class="fancybox-inner">
						<div class="fancybox-infobar">
						<span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span>&nbsp;<span>Фото</span>
						</div>
						<div class="fancybox-toolbar">{{buttons}}</div>
						<div class="fancybox-navigation">{{arrows}}</div>
						<div class="fancybox-stage"></div>
						<div class="fancybox-caption-wrap"><div class="fancybox-caption"></div></div>
					</div>
				</div>`
			}
		};
		if (gallery.length) {
			const isDetail = gallery.hasClass("gallery--detail");
			new Swiper(gallery, isDetail ? settings.galleryDetail : settings.gallery);
			if (isDetail) this.showPopupGallery(elFancy, settings.fancybox);
		}
	}
	showPopupGallery(el, options) {
		el.fancybox(options);
	}
}

$.validator.addMethod(
	"regex",
	function(value, element, regexp) {
		var re = new RegExp(regexp);
		return this.optional(element) || re.test(value);
	},
	"Поле заполнено не верно"
);

class InteractiveForm {
	constructor(el, opts = {}) {
		this.$form = $(el);
		this.isCallTouch = this.$form.data('calltouch');

		let $form = this.$form;

		if ($form.data("action")) {
			$form.prop("action", $form.data("action"));
		}

		let $phoneIntputs = $form.find('[name="phone"], [type="tel"]');

		$phoneIntputs.inputmask({
			mask: "+7 999 999-99-99",
			showMaskOnHover: false
		});

		$form.find('[name="captcha"]').inputmask({
			mask: "99999",
			showMaskOnHover: false
		});

		let validatorOpts = {
			rules: {
				captcha: {
					required: true,
					regex: /\d\d\d\d\d/
				}
			},
			errorElement: "em",
			onfocusout: (el /*, event*/) => {
				$(el).valid();
			},

			focusCleanup: false,
			submitHandler: opts.submitHandler || this.standartFormHandler, //(form)=>{}
			errorPlacement: ($errorLabel, $el) => {
				if ($el.attr("name") === "agree") {
					return true;
				} else {
					$errorLabel.addClass("Form_hint Form_hint-error");
					$el.after($errorLabel);
					return true;
				}
			}
		};

		$phoneIntputs.each((index, el) => {
			validatorOpts.rules[el.name] = {
				required: !!el.required,
				regex: /\+7\s\d\d\d\s\d\d\d\-\d\d\-\d\d/
			};
		});

		if (opts.validatorParams) {
			$.extend(true, validatorOpts, opts.validatorParams);
		}

		if (opts.successBlockMod) {
			$.extend(true, opts, { successBlockMod: "default" });
		}

		this.opts = opts;
		this.validator = $form.validate(validatorOpts);
	}

	standartFormHandler(form) {
		let $form = $(form);
		let isCallTouch = $(form).data('calltouch');
		window.pagePreloader.show();

		let dataToSend = $.extend(true, $form.serializeObject(), {
			Submit: 1,
			url: window.location.href
		});

		if (isCallTouch && window.ctw) {
			let phone = $form.find("input[name=phone]").val().replace(/[^0-9]/g, "");

			window.ctw.createRequest("sereb_form", phone, [
					{
						name: "ФИО",
						value: $form.find("input[name=name]").val()
					}
				],
				
				function (success, data) {

					dataToSend.calltouch = data;

					$.ajax({
						url: form.action,
						type: form.method,
						data: dataToSend,
					})
						.done(response => {
							let errorCode = parseInt(response.code);
							if (errorCode === 0) {
								let successText =
									`<div class="Form_success">` +
									`<div class="Form_successPicwrap"><img src="/img/red_branch_with_bird.svg" alt="------"></div>` +
									`<div class="Form_successTxt ">${response.success}</div>` +
									`</div>`;
								window.requestAnimationFrame(() => {
									$form.hide().after(successText);
								});
							} else if (errorCode === 1) {
								let validator = $form.data("validator");
								$form
									.find('[name="captcha"]:first')
									.val("")
									.trigger("focus");
			
								validator.showErrors({
									captcha: response.error
								});
							} else {
								alert("Не удалось отправить форму! Попробуйте позже или обратитесть по телефону...");
							}
						})
						.always((/*response*/) => {
							window.pagePreloader.hide();
						});

				});
		}
		else {
			$.ajax({
				url: form.action,
				type: form.method,
				data: dataToSend
			})
				.done(response => {
					let errorCode = parseInt(response.code);
					if (errorCode === 0) {
						let successText =
							`<div class="Form_success">` +
							`<div class="Form_successPicwrap"><img src="/img/red_branch_with_bird.svg" alt="------"></div>` +
							`<div class="Form_successTxt ">${response.success}</div>` +
							`</div>`;
						window.requestAnimationFrame(() => {
							$form.hide().after(successText);
						});
					} else if (errorCode === 1) {
						let validator = $form.data("validator");
						$form
							.find('[name="captcha"]:first')
							.val("")
							.trigger("focus");
	
						validator.showErrors({
							captcha: response.error
						});
					} else {
						alert("Не удалось отправить форму! Попробуйте позже или обратитесть по телефону...");
					}
				})
				.always((/*response*/) => {
					window.pagePreloader.hide();
				});
		}
	}

	destroy() {
		this.validator.destroy();
		this.$form.find("input").inputmask("remove");
	}
}

class MapFilter {
	constructor(el, conf) {
		let $el = $(el);

		if (!$el.length) {
			console.error("Map class constructor cant't find target element!");
			return;
		}

        this.$el = $el;
        this.$map = $el.find('.MapFilter_map');
        this.initMap();
        this.$filterItems = $el.find('.MapFilter_filterItem');
    }
    
    initMap() {
        const infrasMap = new GMaps({
            el: this.$map.get(0),
            center: {
                lat: 55.82654485,
                lng: 37.23891061
            },
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
            zoom: 16,
            styles: APP_CONFIGS.gmapsStyles,
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
        });

        this.gmap = infrasMap;

        this.filterMarkers();
        
        this.$map.on("click", ".marker-hover", function() {
            let $el = $(this);
            if (!$el.hasClass("marker-active")) {
                $(".marker-active").removeClass("marker-active");
                $el.addClass("marker-active");
            } else {
                $el.removeClass("marker-active");
            }
        });
    }

    filterMarkers() {
        if (window.MapFilterObjsMarkers) {
            window.MapFilterObjsMarkers = _.sortBy(window.MapFilterObjsMarkers, function(o) {
                return o.coord[0];
            });

            window.markers = [];

            //добавляем базовые маркеры на карту
            window.MapFilterObjsMarkers.forEach(item => {
                clearMarkers();
                if (item.type === 'all') {
                    markers.push(new CustomMarker(this.gmap.map, item.img, item.title, new google.maps.LatLng(...item.coord), item.hover));
                }
            });
        }

        function clearMarkers() {
            $('.marker').each((i, e) => {
                $(e).remove();
            });

            window.markers = [];

        }

        let $filterItems = this.$el.find('.MapFilter_filterItem');
        window.filterField = ['all'];
        let gmap = this.gmap;
        this.$filterItems = $filterItems;
        this.clearMarkers = clearMarkers;
        let resetFilter = this.resetFilter();
        let $filter = this.$el.find('.MapFilter_filter');

        $filterItems.on('click', function (e) {
            e.preventDefault();
            clearMarkers();

            $(this).toggleClass('MapFilter_filterItem-active');

            if ($(this).hasClass('MapFilter_filterItem-active')) {
                //добавляем нужный тип маркеров
                window.filterField.push($(this).data('filtertype'))
            } else {
                //удаляем нужный тип маркеров
                window.filterField.splice(filterField.indexOf($(this).data('filtertype')), 1);
            }

            window.MapFilterObjsMarkers.forEach(item => {
                if (item.type === 'all') {
                    window.markers.push(new CustomMarker(gmap.map, item.img, item.title, new google.maps.LatLng(...item.coord), item.hover));
                }
            });

            //добавляем нужные маркеры на карту согласно фильтру
            window.MapFilterObjsMarkers.forEach(item => {
                
                window.filterField.forEach((i) => {
                    if (item.type === i && item.type !== 'all') {
                        window.markers.push(new CustomMarker(gmap.map, item.img, item.title, new google.maps.LatLng(...item.coord), item.hover));
                    }
                })
            });

        })


        const resetButton = this.$el.find('.MapFilter_reset');
        
        resetButton.on('click', () => {
            this.resetFilter();
        })

        

        $(window).on('load', function () {
            
            $filterItems.each((i, e) => {
                $(e).trigger('click');
            });

            //Хак, при триггере почему-то дублирует несколько одинаковых маркеров. Если найдете ошибку - уберите.
            setTimeout(() => {
                $filterItems.eq(1).trigger('click');
                $filterItems.eq(1).trigger('click');
            }, 300)
        })

        $('.MapFilter_close').on('click', () => {
            $filter.fadeOut(300)
        });

        $('.MapFilter_openBtn').on('click', () => {
            $filter.fadeIn(300)
        });
    }

    resetFilter() {
        
        this.$filterItems.removeClass('MapFilter_filterItem-active');
        this.clearMarkers();

        window.MapFilterObjsMarkers.forEach(item => {
            if (item.type === 'all') {
                window.markers.push(new CustomMarker(this.gmap.map, item.img, item.title, new google.maps.LatLng(...item.coord), item.hover));
            }
        });

        window.filterField = ['all']
    }
}
class MainMenu {
  constructor(el, opts = {}) {
    let $menu = $(el);
    if (!$menu.length) {
      console.error("Menu class constructor cant't find target element!");
      return;
    }

    let $menuHeads = $menu.find(".Menu_groupHead-withSubmenu");

    $menuHeads.on("click", (event) => {
      event.preventDefault();
      let $clickedHead = $(event.target);
      $menuHeads.not($clickedHead).removeClass("Menu_groupHead-submenuOpen");
      $clickedHead.toggleClass("Menu_groupHead-submenuOpen");
    });

    let $closeBtn = $menu.find(".Menu_closeBtn");

    $closeBtn.on("click", (event) => {
      event.preventDefault();
      this.hide();
    });

    this.$menu = $menu;
    this.$closeBtn = $menu.find(".Menu_closeBtn");
    this.opts = opts;
  }

  show() {
    if (this.opts.onShow) this.opts.onShow();
    setTimeout(() => {
      $.fancybox.open(this.$menu, {
        baseClass: "menu-fancybox",
        arrows: false,
        infobar: false,
        toolbar: false,
        buttons: [],
        smallBtn: false,
        touch: false,
        beforeClose: () => {
          if (this.opts.onHide) this.opts.onHide();
          window.requestAnimationFrame(() => {
            this.$menu.removeClass("Menu-active");
          });
        },
      });

      window.requestAnimationFrame(() => {
        this.$menu.addClass("Menu-active");
      });
    }, 100);
  }

  hide() {
    $.fancybox.close();
  }
}

class Message {
	constructor(el, opts = {}) {
		this.opts = opts;
		this.$el = $(el).eq(0);
		this.$el.find(".Message_closeBtn").on("click", event => {
			event.preventDefault();
			this.hide();
			return false;
		});
		this.$content = this.$el.find(".Message_content");
	}

	setContent(content) {
		let markup = `<div class="Message_title Message_title-redColor">${content.title}</div><div class="Message_text">${
			content.text
		}</div>`;
		this.$content.html(markup);
	}

	show() {
		this.$el.fadeIn();
	}

	hide() {
		if (this.opts.beforeHide) {
			this.opts.beforeHide();
		}
		this.$el.fadeOut(/*"400", () => {
            if (this.opts.afterHide) {
                this.opts.afterHide();
            }
        }*/);
	}
}

class Multicheckbox {
	constructor(el) {
		let $el = $(el);
		let $inp = $el.find("input");
		let possibleValues = $inp.data("possible-values");
		$el.on("click", ".Multycheckbox_ico, .Multycheckbox_lbl", event => {
			event.preventDefault();

			for (let i = possibleValues.length - 1; i >= 0; i--) {
				possibleValues[i] = possibleValues[i] + "";
			}
			let currentVal = $inp.val() + "";
			let currentValIndex = _.indexOf(possibleValues, currentVal);
			let newVal;
			if (currentValIndex === possibleValues.length - 1) {
				newVal = possibleValues[0];
			} else {
				newVal = possibleValues[currentValIndex + 1];
			}
			$inp.val(newVal).trigger("change");
		});

		this.$el = $el;
		this.$inp = $inp;
		this.initialValue = possibleValues[0];
	}

	reset() {
		this.$inp.val(this.initialValue).trigger("change");
	}
}

class PopBnr {
	constructor(el, opts = {}) {
		this.$el = $(el);

		if (opts.showMode === "session") {
			// show once per session
			let wasShown = window.sessionStorage.getItem("wasBannerShown");
			if (!wasShown) {
				window.sessionStorage.setItem("wasBannerShown", "1");
				this.show();
			}
		} else {
			// show by default if 'showMode' is not setted
			this.show();
		}
	}

	show() {
		$.fancybox.open(this.$el, {
			smallBtn: true,
			touch: false,
			toolbar: false
		});
	}
}

class PopupBtn {
	constructor(element) {
		let $el = $(element);
		this.tl = null;
		this.$content = $el.find(".PopupBtn_content");
		this.$btn = $el.find(".PopupBtn_btn");
		this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

		this.isArticleBurger = $el.hasClass('PopupBtn-articleBurger');

		if (!this.isFirefox) {
			$(window).on("resize.PopupBtn", _.debounce(this.initAnimate.bind(this), 100));
			this.initAnimate();
		} else {
			$el.addClass('PopupBtn-fierfox')
		}
		this.$btn.on("click", () => {
			if (!this.$btn.hasClass("PopupBtn_btn-open")) {
				this.$btn.addClass("PopupBtn_btn-open");
				if (!this.isFirefox) {
					this.tl.play();
				} else {
					this.$content.fadeIn(400);
				}
			} else {
				this.$btn.removeClass("PopupBtn_btn-open");
				if (!this.isFirefox) {
					this.tl.reverse();
				} else {
					this.$content.fadeOut(400);
				}
			}
		});

		this.$el = $el;

		if (this.isArticleBurger) {
			this.scrollLinks()
		}
	}

	initAnimate() {
		let ended = false;
		if (this.tl != null && this.tl.progress() == 1) {
			ended = true;
		}
		this.$content.show()
		this.tl = new TimelineLite({ paused: true });
		let w = this.$content.width();
		let h = this.$content.height();
		this.tl
			.fromTo(
				this.$content,
				0.3,
				{
					clip: `rect(0px, ${w}px, 0px, ${w - 10}px)`
				},
				{
					clip: `rect(0px, ${w}px, ${h}px, ${w - 10}px)`
				}
			)
			.to(this.$content, 0.3, {
				clip: `rect(0px, ${w}px, ${h}px, 0px)`
			})
			.fromTo(this.$content.children(), 0.3, { opacity: 0 }, { opacity: 1 }, "-=0.3");
		if (ended) {
			this.tl.progress(1);
		}
	}

	scrollLinks() {
		const links = this.$el.find('[data-scrollTo]');

		links.on('click', function (e) {
			e.preventDefault();

			const dataLink = $(this).data('scrollto');
			const title = $(document).find(`[data-titlescroll="${dataLink}"]`);

			$('html, body').animate({
				scrollTop: title.offset().top
			}, 2000);
		})
	}
}

class Preloader {
	constructor(selector) {
		let $el = $(selector);

		if (!$el.length) {
			console.error("Preloader class constructor cant't find target element!");
			return;
		}

		$el.get(0).onclick = event => {
			event.preventDefault();
			event.stopPropagation();
			return false;
		};

		this.$el = $el;
		this.isLocked = false;
	}

	show(cb) {
		if (this.isLocked) return false;
		this.$el.fadeIn(cb);
	}

	hide(cb) {
		if (this.isLocked) return false;
		this.$el.fadeOut(cb);
	}
}

class RangeSlider {
	constructor(el) {
		if (!el) {
			console.error('RangeSlider constructor can\'t find given "el" in DOM!');
			return;
		}

		let $el = $(el);

		let $inputs = $el.find("input");
		let $inpMin = $inputs.eq(0);
		let $inpMax = $inputs.eq(1);

		let inlineElOpts = $el.data("slider-opts");
		let counterType = inlineElOpts.counterType || "num";
		let minVal = inlineElOpts.min;
		let maxVal = inlineElOpts.max;

		let currentMinVal = parseInt($inpMin.val());
		let currentMaxVal = parseInt($inpMax.val());

		let $minValCounter = $el.find(".RangeSlider_minValViewEl");
		let $maxValCounter = $el.find(".RangeSlider_maxValViewEl");

		if (counterType === "date_quarters") {
			this.quarterPoints = this._getQuartersFromRange(minVal, maxVal);
			minVal = 0;
			maxVal = this.quarterPoints.length - 1;

			let currentValuesQuaters = this._getQuartersFromRange(currentMinVal, currentMaxVal);

			currentMinVal = _.findIndex(this.quarterPoints, (t) => {
				return currentValuesQuaters[0].utc === t.utc;
			});

			currentMaxVal = _.findIndex(this.quarterPoints, (t) => {
				return _.last(currentValuesQuaters).utc === t.utc;
			});
		}

		let options = {
			classes: {
				"ui-slider-handle": "RangeSlider_handle",
				"ui-slider-range": "RangeSlider_progress",
			},
			slide: (event, ui) => {
				// let min = ui.values[0];
				// let max = ui.values[1];

				// if (min * 1.05 >= max) {
				// 	return false;
				// }

				this.renderValuesToCounterEl(ui.values);
			},
			change: (event, ui) => {
				this.setValuesToInputs(ui.values[0], ui.values[1], !!event.originalEvent);
			},
			values: [currentMinVal, currentMaxVal],
			min: minVal,
			max: maxVal,
			step: inlineElOpts.step || 1,
			range: true,
		};

		let $track = $("<div class='RangeSlider_track'></div>");
		$track.slider(options).prependTo($el);

		if (counterType !== "date_quarters") {
			$minValCounter.add($maxValCounter).on("click", (event) => {
				let $counter = $(event.currentTarget);
				if ($counter.find("input").length || $counter.is("input")) return false;
				let $inp = $counter.hasClass("RangeSlider_minValViewEl") ? $inpMin : $inpMax;
				let $popupInp = $("<input type='text' class='RangeSlider_popupInp'>");

				$popupInp
					.val($inp.val())
					.inputmask("integer", {
						groupSeparator: " ",
						autoGroup: true,
						allowMinus: false,
						rightAlign: false,
					})
					.on("change", (event) => {
						event.preventDefault();

						let $tmpInp = $(event.currentTarget);
						let val = parseInt(
							$tmpInp
								.val()
								.split(" ")
								.join("")
						);

						if (isNaN(val)) {
							val = $inp.val();
						} else {
							$inp.val(val);
						}

						let newVals = [parseInt($inpMin.val()), parseInt($inpMax.val())];

						if (newVals[0] > newVals[1]) {
							newVals = [newVals[1], newVals[0]];
						}

						if (newVals[0] < minVal) newVals[0] = minVal;
						if (newVals[1] > maxVal) newVals[1] = maxVal;

						-

						$track.slider("values", newVals);

						this.renderValuesToCounterEl(newVals);
						$tmpInp.remove();
						return false;
					})
					.on(
						"focusout",
						_.debounce(() => {
							
							$popupInp.remove();
							$('body').removeClass('keyboard-detect');

						}, 80)
					);

				$counter.parent().append($popupInp);
				$popupInp.trigger("focus");

				$('body').addClass('keyboard-detect');
			});
		}
		this.$minValCounter = $minValCounter;
		this.$maxValCounter = $maxValCounter;

		this.$inpMin = $inpMin;
		this.$inpMax = $inpMax;

		this.minMaxValues = [minVal, maxVal];

		this.counterType = counterType;

		this.$track = $track;

		this.renderValuesToCounterEl($track.slider("values"));
	}

	setValuesToInputs(min, max, fireChangeEvent) {
		if (this.counterType === "date_quarters") {
			min = this.quarterPoints[min].utc;
			max = this.quarterPoints[max].utc;
		}
		this.$inpMin.val(min);
		this.$inpMax.val(max);

		if (fireChangeEvent) {
			this.$inpMax.trigger("change");
		}
	}

	_getQuartersFromRange(start, end) {
		let startDate = new Date(start * 1000);
		let endDate = new Date(end * 1000);
		let result = [];

		let quarterPoints = [moment(startDate).unix()];
		let tmpQuarterPoint = startDate;

		while (tmpQuarterPoint < endDate) {
			tmpQuarterPoint = moment(tmpQuarterPoint)
				.add(3, "months")
				.endOf("quarter")
				.toDate();
			quarterPoints.push(moment(tmpQuarterPoint).unix());
		}

		let fmtTpl = "Q кв. YYYY";

		let titles = [];

		for (let i = 0; i < quarterPoints.length; i++) {
			let romanNumbers = ["I", "II", "III", "IV"];

			let titleStr = moment.unix(quarterPoints[i]).format(fmtTpl);
			let quartIndex = parseInt(titleStr) - 1;
			titleStr = romanNumbers[quartIndex] + titleStr.slice(1, titleStr.lenght);
			titles.push(titleStr);
		}

		for (var i = 0; i < titles.length; i++) {
			result.push({
				utc: quarterPoints[i],
				title: titles[i],
			});
		}
		return result;
	}

	renderValuesToCounterEl(vals) {
		if (this.counterType) {
			switch (this.counterType) {
				case "formatted_num":
					vals = _.mapValues(vals, (item) => {
						return item.toLocaleString("ru-RU");
					});

					break;

				case "date_quarters":
					vals = _.mapValues(vals, (item) => {
						return this.quarterPoints[item].title;
					});
					break;
			}
		}

		window.requestAnimationFrame(() => {
			this.$minValCounter.html(vals[0]);
			this.$maxValCounter.html(vals[1]);
		});
	}

	updateRange(minMax, fireChangeEvent) {
		this.$track.slider("values", minMax);
		this.renderValuesToCounterEl(minMax);
		this.setValuesToInputs(minMax[0], minMax[1], fireChangeEvent);
	}

	reset() {
		this.updateRange(this.minMaxValues);
	}
}

class Slideshow {
	constructor(el, opts = {}) {
		if (!el) {
			throw new Error("Slideshow class requires at least one argument!");
		}
		let $el = $(el);
		let defaultOptions = {
			speed: 1000,
			loop: true,
			effect: "fade",
			allowTouchMove: true,
			navigation: {
				prevEl: $el.find(".Slideshow_arrow-prev").get(0),
				nextEl: $el.find(".Slideshow_arrow-next").get(0)
			},
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				delay: 9000,
				disableOnInteraction: false
			}
		};

		let sliderInstance = new Swiper($el.find(".swiper-container").get(0), $.extend(defaultOptions, opts));

		this.$el = $el;
		this.sliderInstance = sliderInstance;
	}

	/*destroy() {
        this.sliderInstance.trigger('destroy.owl.carousel');
    }*/
}

class Tbl {
	constructor(el, opts = {}) {
		this.$el = $(el);
		this.$heads = this.$el.find(".Tbl_thead").find(".Tbl_th");

		this.$heads.filter("[data-sort-by]").on("click", event => {
			event.preventDefault();
			let $th = $(event.currentTarget);
			let sortName = $th.data("sort-by");

			this.$heads.not($th).removeClass("Tbl_th-sortableActive Tbl_th-sortable");
			$th.addClass("Tbl_th-sortable").toggleClass("Tbl_th-sortableActive");
			let direction = $th.hasClass("Tbl_th-sortableActive") ? "desc" : "asc";

			if (opts.onSortChange) {
				opts.onSortChange(sortName, direction);
			}
		});
	}
}

class Teaser {
	constructor(el) {
		let $el = $(el);
		if (currentDevice.desktop()) {
			$el.find(".Teaser_picWrap").hover3d({
				shine: false,
				selector: $el.find(".Teaser_picture"),
				sensitivity: 40,
				// invert planning in FF because of strange bag
				invert: true
			});
		}

		$el.find(".Teaser_picture-withGallery").on("click", function(event) {
			event.preventDefault();
			$.ajax({
				url: event.target.dataset.srcJson,
				dataType: "json"
			})
				.done(items => {
					$.fancybox.open(items, {
						loop: true
					});
				})
				.fail(function() {
					console.error("Can't get gallery data from server!");
				});
		});
	}
}

class TimerModal {
	constructor(el, opts = {}) {
    this.$el = $(el);
    var $el = this.$el;
    var secondsBefore = $el.data('timer');
    var timerWasClosed = false; /* localStorage.getItem("timerWasClosed"); */

    if (secondsBefore == 0 || timerWasClosed) {
      return;
    }

    setInterval(() => {
      var days;
      var hours;
      var minutes;
      var seconds;

      secondsBefore = secondsBefore - 1;
      days = Math.floor(secondsBefore / 86400);
      hours = Math.floor((secondsBefore / 3600) - (days * 24));
      minutes = Math.floor((secondsBefore / 60) - (days * 1440) - (hours * 60));
      seconds = Math.floor(secondsBefore - (days * 86400) - (minutes * 60) - (hours * 3600));
      
      this.renderTimes(days, hours, minutes, seconds);
    }, 1000);

    $(document).ready(() => this.show());

    $el.find('.TimeCounter_close').on('click', ()=> {
      this.hide()
      localStorage.setItem("timerWasClosed", true);
    });

  }
  
  renderTimes(days, hours, min, sec) {
    var $innerTime = this.$el.find('[data-time]');
    var days = this.formatZeroDate(days);
    var hours = this.formatZeroDate(hours);
    var min = this.formatZeroDate(min);
    var sec = this.formatZeroDate(sec);
    var declOfNum = this.declOfNum;

    $innerTime.each(function () {
      var typeDate = $(this).data('time');
      var $dateCell = $(this).children();
      var $timeDesc = $(this).children('.TimeCounter_numbsName');

      if (typeDate === 'days') {
        $timeDesc.text(declOfNum(days, ["День", "Дня", "Дней"]));
        days = days.split('');

        $dateCell.eq(0).text(days[0]);
        $dateCell.eq(1).text(days[1]);

      }
      else if (typeDate === 'hours') {
        $timeDesc.text(declOfNum(hours, ["Час", "Часа", "Часов"]));
        hours = hours.split('');

        $dateCell.eq(0).text(hours[0]);
        $dateCell.eq(1).text(hours[1]);

      }
      else if (typeDate === 'minutes') {
        $timeDesc.text(declOfNum(min, ["Минута", "Минут", "Минут"]));
        min = min.split('');

        $dateCell.eq(0).text(min[0]);
        $dateCell.eq(1).text(min[1]);

      }
      else if (typeDate === 'seconds') {
        $timeDesc.text(declOfNum(sec, ["Секунда", "Секунды", "Секунд"]));
        sec = sec.split('');

        $dateCell.eq(0).text(sec[0]);
        $dateCell.eq(1).text(sec[1]);

      }
    });

  }

  formatZeroDate(dateItem) {
    var dateItem = dateItem + '';
    
    if (dateItem.length == 1) {
      dateItem = '0' + dateItem;
    }

    return dateItem;
  }

  declOfNum(number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];

    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
  }

  show() {
    this.$el.addClass('TimeCounter-active');
  }

  hide() {
    this.$el.removeClass('TimeCounter-active');
  }

  toggle() {
    this.$el.toggleClass('TimeCounter-active');
  }
}

class TransportMap {
	constructor(el, conf) {
		let $el = $(el);

		if (!$el.length) {
			console.error("Map class constructor cant't find target element!");
			return;
		}

        this.$el = $el;
        this.$map = $el.find('.TransportMap_map');
        this.initMap();
    }
    
    initMap() {
        let $transportMap = $("#transportMap");

let mapParams = {
	el: this.$map.get(0),
	center: APP_CONFIGS.buildingLatLng,
	disableDefaultUI: true,
	zoomControl: true,
	zoomControlOptions: {
		position: google.maps.ControlPosition.LEFT_BOTTOM
	},
	zoom: 16,
	styles: APP_CONFIGS.gmapsStyles,
	streetViewControl: true,
	streetViewControlOptions: {
		position: google.maps.ControlPosition.LEFT_BOTTOM
	},
};

let windowBreakpoint = getWindowSizeBreakpoint();

if (windowBreakpoint === "md") {
	mapParams.center = {
		lat: APP_CONFIGS.buildingLatLng.lat,
		lng: APP_CONFIGS.buildingLatLng.lng + 0.0075
	};
} else if (windowBreakpoint === "sm") {
	mapParams.zoom = 14;
	mapParams.center = {
		lat: APP_CONFIGS.buildingLatLng.lat + 0.003,
		lng: APP_CONFIGS.buildingLatLng.lng + 0.009
	};
} else if (windowBreakpoint === "xs") {
	mapParams.center = {
		lat: APP_CONFIGS.buildingLatLng.lat + 0.0033,
		lng: APP_CONFIGS.buildingLatLng.lng + 0.006
	};
	mapParams.zoom = 14;
}

const transportMap = new GMaps(mapParams);

{
	var path = [
		[55.8310593769994, 37.233914198105055],
		[55.83029851863924, 37.2379589692995],
		[55.82961011011211, 37.2413814680025],
		[55.82732740479738, 37.23936444682331],
		[55.82806416565615, 37.23661786479206],
		[55.82706168431912, 37.23550206584191],
		[55.82826948997036, 37.231704057876826],
		[55.8310593769994, 37.233914198105055]
	];

	transportMap.drawPolygon({
		paths: path,
		strokeColor: "#c43f60",
		strokeOpacity: 1,
		strokeWeight: 2,
		fillColor: "#c43f60",
		fillOpacity: 0.3
	});
}

if (window.infrasObjsMarkers) {
	window.infrasObjsMarkers = _.sortBy(window.infrasObjsMarkers, function(o) {
		return o.coord[0];
	});
	window.infrasObjsMarkers.forEach(item => {
		new CustomMarker(transportMap.map, item.img, item.title, new google.maps.LatLng(...item.coord), item.hover);
	});
}

$transportMap.on("click", ".marker-hover", function() {
	let $el = $(this);
	if (!$el.hasClass("marker-active")) {
		$(".marker-active").removeClass("marker-active");
		$el.addClass("marker-active");
	} else {
		$el.removeClass("marker-active");
	}
});

let messageBox = new Message(".Message", {
	beforeHide: () => {
		transportMap.cleanRoute();

		let optimalZoom = transportMap.getZoom() + 1;
		if (optimalZoom > 16) {
			optimalZoom = 16;
		}
		transportMap.setCenter(APP_CONFIGS.buildingLatLng);
		transportMap.setZoom(optimalZoom);
	}
});

let $filter = this.$el.find('.TransportMap_filter');
let $closeBtn  = this.$el.find('.TransportMap_close');

$closeBtn.on('click', function () {
	$filter.fadeOut(300)
});

this.$el.find('.TransportMap_open').on('click', function () {
	$filter.fadeIn(300)
})

$("#listsOfRoutes")
	.find("a")
	.on("click", function(event) {
		event.preventDefault();
		let $link = $(event.currentTarget);
		let routeIndex = parseInt($link.attr("href").split("#route_")[1]);
		let routeData = window.routesDesctiptions[routeIndex];
		console.log(routeData)
		$closeBtn.trigger('click');

		transportMap.cleanRoute();

		let dest = routeData.destination || [APP_CONFIGS.buildingLatLng.lat, APP_CONFIGS.buildingLatLng.lng];
		let tm = routeData.travelMode || "driving";
		let waypts = [];
		if (routeData.waypoints && tm !== "transit") {
			for (var i = routeData.waypoints.length - 1; i >= 0; i--) {
				waypts.push({
					location: routeData.waypoints[i]
				});
			}
		}

		// выводим маршрут следования, интервалами
		for (var ii = 1; ii < window.routesDesctiptions2[routeIndex].waypoints.length; ii++) {
			let start = window.routesDesctiptions2[routeIndex].waypoints[ii - 1];
			let finish = window.routesDesctiptions2[routeIndex].waypoints[ii];

			if (finish.mode == "WALKING") finish.mode = "walk";
			if (finish.mode == "TRANSIT") finish.mode = "transit";
			if (finish.mode == "DRIVING") finish.mode = "driving";

			if (finish.mode == "walk") {
				transportMap.drawRoute({
					origin: [start.lat, start.lng],
					destination: [finish.lat, finish.lng],
					strokeOpacity: 0,
					icons: [
						{
							icon: {
								path: "M 0,-1 0,1",
								strokeOpacity: 1,
								strokeColor: "#c43f60",
								strokeWeight: 3,
								scale: 4
							},
							offset: "0",
							repeat: "25px"
						}
					],
					// waypoints: [],
					travelMode: finish.mode
				});
			} else {
				transportMap.drawRoute({
					origin: [start.lat, start.lng],
					destination: [finish.lat, finish.lng],
					strokeColor: "#9893c0",
					strokeOpacity: 1,
					strokeWeight: 3,
					// waypoints: [],
					travelMode: finish.mode
				});
			}
		}

		transportMap.fitLatLngBounds([
			{
				lat: routeData.origin[0],
				lng: routeData.origin[1]
			},
			{
				lat: dest[0],
				lng: dest[1]
			}
		]);

		messageBox.setContent(routeData);
		messageBox.show();
		$("#showRoutesListBtn").trigger("click");
	});

    }
}

function getWindowSizeBreakpoint() {
  let w = window.innerWidth;
  let result = "md";
  if (w < 768) {
    result = "xs";
  } else if (w > 767 && w < 1440) {
    result = "sm";
  }
  return result;
}

function prepareFilterFormValues(valsObj) {
  return _.mapValues(valsObj, (param) => {
    // convert all strings and arrays from inputs to 'INT' type
    let result;
    if (_.isString(param)) {
      result = parseInt(param);
    } else if (_.isArray(param)) {
      result = _.map(param, (p) => {
        return parseInt(p);
      });
    }
    return result;
  });
}

const currentDevice = device.default;

let menuBurger = new CustomBurger(".Header_menuBtn");
let mainMenu = new MainMenu(".Menu", {
  onShow: () => {
    menuBurger.drawClosedBurger();
  },
  onHide: () => {
    menuBurger.reset();
  },
});

$(".Header_menuBtn").on("click", (event) => {
  event.preventDefault();
  mainMenu.show();
  return false;
});

new InteractiveForm($("#orderModal").find(".Form"));

let $window = $(window);

$(".Teaser").each((index, el) => {
  new Teaser(el);
});

let loadedPage = false;

$window.on("load", () => {
  if ($window.scrollTop() < 100) {
    new WOW().init({
      live: false,
    });
  }
  {
    let $PopupBtn = $(".PopupBtn");
    if ($PopupBtn.length) {
      $PopupBtn.each((i, e) => {
        new PopupBtn(e);
      });
    }

    let $bird = $(".Bird");

    if ($bird.length) {
      if ($PopupBtn.length) {
        let birdFly = new Bird($PopupBtn);
        birdFly.startAnimation();
      } else {
        $bird.hide();
        console.error("Bird's target element not found in DOM!");
      }
    }
  }
  loadedPage = true;
  window.pagePreloader.hide();

  new BackToTop("#backtotop");
});

window.pagePreloader = new Preloader("#pagePreloader");

if ($(".ArticleBurger").length) {
  const articleBurger = new ArticleBurger(
    document.querySelector(".ArticleBurger")
  );
}

$(function () {
  $("#OnlineCamTabs").tabs({
    active: 3,
    //disabled: [ 0, 1, 2, 4 ]
  });
});

let i = 1;
while (i < 6) {
  let OnlineCamView = "#OnlineCamView_" + i;
  $(function () {
    $(OnlineCamView).tabs();
  });
  //alert(OnlineCamView);
  i++;
}

//#OnlineCamView_4

$(".FilterForm_groupToggler").each(function (i, e) {
  var $elem = $(e);

  if ($elem[0]) {
    $(document).on("click", function (e) {
      if (
        $elem.hasClass("FilterForm_groupToggler-active") &&
        !$(e.target).closest(".FilterForm_groupToggler").length &&
        !$(e.target).closest(".FilterForm_chksGroup-groupBlock").length
      ) {
        $elem.removeClass("FilterForm_groupToggler-active");
        $(".FilterForm_item-group").hide();
      }
    });
  }
});

$("[data-scrollToTop]").on("click", function () {
  let elementScroll = $(this).attr("data-scrollToTop");
  let destination = $(elementScroll).offset().top;
  $("body, html").animate({ scrollTop: destination }, 1500);
});

$("[data-showEl]").on("click", function () {
  let elementClick = $(this).attr("data-showEl");
  $(elementClick).addClass("_open");
});

//Фикс клавиатуры на мобилках
$("input, textarea").on("focus", function () {
  $("body").addClass("keyboard-detect");
});

let resultTable = $("#filterResultsContainer");
let btnBuyOnline = "[data-btn-buyonline]";
let btnBuyOnlineFlat = "[data-btn-buyonline-flat]";
let btnBuyOnlinePopup = $("#popupBuyOnline");
let currentHref;

resultTable.on("click", function (e) {
  if ($(e.target).is($(btnBuyOnline))) {
    e.preventDefault();
    currentHref = $(e.target).attr("href");
    showPopupBuyOnline();
  }
});

$(btnBuyOnlineFlat).on("click", function (e) {
  e.preventDefault();
  currentHref = $(this).attr("href");
  showPopupBuyOnline();
});

function showPopupBuyOnline() {
  $.fancybox.open(btnBuyOnlinePopup, {
    touch: {
      vertical: false,
      momentum: false,
    },
    buttons: ["close"],
    afterShow: function () {
      btnBuyOnlinePopup
        .find("[data-buyonline-booking]")
        .attr("href", currentHref);
    },
  });
}

$("[data-youtube-video]").each((i, e) => {
  $(e).on("click", function (e) {
    e.preventDefault();
    const url = $(this).data("src");
    $.fancybox.open(
      `<div class="YoutubeVideoPlayer"><iframe width="560" height="315" src="${url}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`,
      {
        closeBtn: true,
      }
    );
  });
});
